export default abstract class AppError extends Error {
  public statusCode = 500
  public handled = true
}
